import { curry, flow, prop, sortBy, last, filter } from 'lodash/fp'

import { Organization } from '../organizations/types'
import { DigitalPresenceType, DigitalPresence } from './types'

const getDigitalPresenceTypeValue = curry(
  (seekedType: DigitalPresenceType, { digitalPresence }: Partial<Organization>): string | undefined => {
    return flow(
      filter((item: DigitalPresence) => item.type === seekedType),
      sortBy('updatedAt'),
      last,
      prop('value')
    )(digitalPresence || [])
  }
)

export const getOrganizationLinkedinUrl = getDigitalPresenceTypeValue(DigitalPresenceType.linkedinUrl)
export const getOrganizationTwitterUrl = getDigitalPresenceTypeValue(DigitalPresenceType.twitterUrl)
export const getOrganizationFacebookUrl = getDigitalPresenceTypeValue(DigitalPresenceType.facebookUrl)
export const getOrganizationWebsiteUrl = getDigitalPresenceTypeValue(DigitalPresenceType.websiteUrl)
export const getOrganizationLogoUrl = getDigitalPresenceTypeValue(DigitalPresenceType.logoUrl)
